"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Mouse, Terminal } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheLabAlphaHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="228501" id="capture-the-pulse" className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 w-full h-full z-0">
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/studio_mixing_poster.png">
          <source src="/video/retro-lab-bg.mp4" type="video/mp4" />
          <source src="/video/retro-lab-bg.webm" type="video/webm" />
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/studio_mixing_poster.png" alt="PulseWave Studios Background" className="absolute inset-0 w-full h-full object-cover" />
        </video>
      </div>

      {}
      <div className="absolute inset-0 bg-white/40 dark:bg-black/60 z-10 pointer-events-none"></div>

      {}
      <div className="absolute inset-0 z-20 pointer-events-none opacity-20" style={{
      backgroundImage: "repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,0,0,0.8) 2px, rgba(0,0,0,0.8) 4px)"
    }}></div>

      {}
      <div ref={ref} className={`relative z-30 flex flex-col items-center text-center px-4 max-w-5xl mx-auto transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="flex items-center gap-2 mb-6 text-primary animate-pulse">
          <Terminal className="w-6 h-6" />
          <span className="font-mono text-sm tracking-widest uppercase">Recording Live</span>
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-default font-bold uppercase tracking-tighter mb-6 text-transparent bg-clip-text bg-gradient-to-b from-foreground to-foreground/70 drop-shadow-[0_0_15px_rgba(0,0,0,0.2)] dark:drop-shadow-[0_0_15px_rgba(0,255,255,0.3)]">
          Sound That <br className="hidden md:block" /> Resonates
        </h1>

        <p className="text-lg md:text-xl max-w-2xl mb-10 font-default text-primary">
          A collaborative sanctuary where cutting-edge technology meets artistic expertise. 
          Bring your sonic vision to life with high-fidelity precision.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 items-center">
          <Button asChild size="lg" className="h-14 px-8 rounded-full border-2 border-primary bg-primary text-primary-foreground hover:bg-transparent hover:text-primary shadow-md dark:shadow-[0_0_20px_rgba(0,255,255,0.4)] hover:shadow-lg dark:hover:shadow-[0_0_30px_rgba(0,255,255,0.6)] transition-all duration-300 uppercase tracking-widest font-bold text-lg">
            <Link to="/ServicesPage">Start Your Journey</Link>
          </Button>

          <Button asChild size="lg" variant="ghost" className="h-14 px-8 rounded-full border border-border dark:border-white/10 hover:border-primary/50 text-foreground backdrop-blur-md bg-secondary/50 dark:bg-white/5 hover:bg-secondary/80 dark:hover:bg-white/10 transition-all duration-300 uppercase tracking-widest font-bold text-lg">
            <Link to="#" newTab>
              Watch Reel
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 flex flex-col items-center gap-2 opacity-70 hover:opacity-100 transition-opacity">
        <span className="text-xs font-mono uppercase tracking-widest text-foreground/70 dark:text-muted-foreground">Scroll</span>
        <Mouse className="w-6 h-6 text-primary animate-bounce" />
      </div>
    </section>;
}